import {Component, EventEmitter, Output} from '@angular/core';
import {AuthHolderService} from '../../../domain/auth-holder.service';

@Component({
    selector: 'af-faq-tab',
    templateUrl: 'faq-tab.component.html',
    standalone: false,
})
export class FaqTabComponent {
    @Output() addQuestionClickListener = new EventEmitter<void>();
    @Output() hasDataListener = new EventEmitter<boolean>();

    isAdmin = this.authHolderService.hasAccess(['npck-admin']);

    constructor(private authHolderService: AuthHolderService) {
    }
}
